.modal-dialog-wrap {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  .modal-dialog-back-drop {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
    &.enter {
      opacity: 0;
    }
    &.enter-active {
      transition: opacity 200ms ease-in-out;
      opacity: 1;
    }
    &.enter-done {
      opacity: 1;
    }
    &.exit {
      opacity: 1;
    }
    &.exit-active {
      transition: opacity 200ms ease-in-out;
      opacity: 0;
    }
    &.exit-done {
      opacity: 0;
    }
  }
  .modal-dialog-desktop-container {
    position: fixed;
    top: calc(50% + 40px);
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 2;
    box-shadow: 0 0 32px rgba(0, 0, 0, 0.1);
    background: var(--gray-white);
    border-radius: 16px;
    @media (max-width: 1200px) {
      top: 50%;
    }
    &.enter {
      opacity: 0;
    }
    &.enter-active {
      animation: xMWSpreadIn 0.3s;
      opacity: 1;
    }
    &.enter-done {
      opacity: 1;
    }
    &.exit {
      opacity: 1;
    }
    &.exit-active {
      animation: xMWSpreadOut 0.3s;
      opacity: 0;
    }
    &.exit-done {
      opacity: 0;
    }
  }
  .modal-dialog-mobile-container {
    position: fixed;
    top: 50%;
    left: 50%;
    z-index: 2;
    user-select: none;
    outline: 0;
    transform: translate(-50%, -50%);
    width: calc(100% - 32px);
    overflow: hidden;
    .modal-dialog-root {
      width: 100%;
    }
    &.enter {
      opacity: 0;
    }
    &.enter-active {
      animation: xMWSpreadIn 0.3s;
      opacity: 1;
    }
    &.enter-done {
      opacity: 1;
    }
    &.exit {
      opacity: 1;
    }
    &.exit-active {
      animation: xMWSpreadOut 0.3s;
      opacity: 0;
    }
    &.exit-done {
      opacity: 0;
    }
  }
  .modal-dialog-root {
    background-color: rgb(255, 255, 255);
    color: rgba(0, 0, 0, 0.87);
    border-radius: 16px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    width: 400px;
    max-height: calc(100% - 64px);
  }

  .modal-dialog-content {
    list-style: none;
  }

  @keyframes xMWSpreadIn {
    0% {
      opacity: 0;
      transform: translate(-50%, -50%) scale(0);
    }
    100% {
      opacity: 1;
      transform: translate(-50%, -50%) scale(1);
    }
  }

  @keyframes xMWSpreadOut {
    0% {
      opacity: 1;
      transform: translate(-50%, -50%) scale(1);
    }
    100% {
      opacity: 0;
      transform: translate(-50%, -50%) scale(0);
    }
  }
}
